import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";

/*
 * Stores and submits completed surveys (and related actions) to the API.
 * Per configuration:
 *  - Web: requests are flushed immediately.
 *  - App: requests are enqueued, flushed on a particular schedule.
 */
import Platform from 'quasar/src/plugins/Platform.js';;
import Vue from 'vue';
import { make } from 'vuex-pathify';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { FIB } from "../../config/constants"; // Set the amount of time we wait to see if we get connection
// Time is set in hundredths of a second (10 = 1sec)

var timeoutTime = process.env.TIMEOUT_TIME;

var resubmitSurveyTimeout = function resubmitSurveyTimeout(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var US = FIB.US; // Use constants for Update States

var cleanCurrent = {
  requests: [],
  // The queue of requests to send to the api
  results: {},
  // All shared results for the submission
  flushInProgress: false,
  // Track whether a flush is in progress or not
  offlineSurveyID: 0
};

var defaultState = function defaultState() {
  return {
    lastUpdated: null,
    marketingPermitted: false,
    responsesTemp: [],
    // Temporary storage for completed responses, only used by the app
    updateState: US.UNKNOWN,
    // Responses update state
    current: cloneDeep(cleanCurrent),
    // The current response being built/sent
    sending: false,
    failedToSubmit: false,
    submittedSurveys: 0,
    isAiValid: false // value for if responses are able to produce a valid AI response

  };
};

var state = defaultState();
var SUBMISSION_TYPES = {
  SUBMIT: 'submit',
  UPLOAD: 'upload',
  DELETE_UPLOAD: 'deleteUpload',
  TRACK: 'track'
};

var removeAllOfType = function removeAllOfType(current, type) {
  var index = -1;

  while ((index = current.requests.findIndex(function (r) {
    return r.type === type;
  })) !== -1) {
    current.requests.splice(index, 1);
  }
};

var actions = _objectSpread(_objectSpread({}, make.actions(state)), {}, {
  // Make default actions
  //////////////////////////////////////////////////////////////////////////////////////////////////
  //    ___                        __         _         _
  //   / _ | ___  ___    ___ __ __/ /  __ _  (_)__ ___ (_)__  ___
  //  / __ |/ _ \/ _ \  (_-</ // / _ \/  ' \/ (_-<(_-</ / _ \/ _ \
  // /_/ |_/ .__/ .__/ /___/\_,_/_.__/_/_/_/_/___/___/_/\___/_//_/
  //      /_/  /_/
  //

  /**
   * Upload survey responses for the app.
   *
   * @param {Object} state Vuex module state
   * @param {Function} commit Vuex module commit
   * @param {Object} rootState Vuex root state
   * @param {Function} dispatch Vuex module dispatch
   *
   * @returns {Boolean} True when successful, false otherwise
   */
  sendResponses: function sendResponses(_ref) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, dispatch, rootState, state, uploadResponses;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, dispatch = _ref.dispatch, rootState = _ref.rootState, state = _ref.state;

              if (!(state.responsesTemp.length === 0)) {
                _context.next = 4;
                break;
              }

              Logger.debug('No survey responses to upload');
              return _context.abrupt("return", true);

            case 4:
              if (rootState.settings.hasConnectivity) {
                _context.next = 7;
                break;
              }

              Logger.warn('Cannot upload survey responses while offline');
              return _context.abrupt("return", false);

            case 7:
              // Set the update state to in progress
              Logger.debug('Begin upload process');
              commit('setUpdateState', US.IN_PROGRESS);
              commit('current', {
                requests: state.responsesTemp,
                results: {},
                flushInProgress: false
              });
              _context.next = 12;
              return dispatch('__flush', 4);

            case 12:
              uploadResponses = _context.sent;
              // Set the update state based on the number of responses left to upload, if any
              Logger.debug('End upload process');
              commit('setUpdateState', state.responsesTemp.length ? US.PENDING : US.DONE); // Set last updated timestamp

              if (state.submittedSurveys > 0) {
                commit('lastUpdated', moment().unix());
              }

              if (!(uploadResponses === false)) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return", false);

            case 20:
              return _context.abrupt("return", true);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  // The following methods: __flush & __request, provide infrastructure and should *not* be used outside of this module (hence the __s)

  /**
   * Flush all enqueue requests
   *
   * @param {Object} state Vuex module state
   * @param {Function} commit Vuex module commit
   * @param {Function} dispatch Vuex module dispatch
   */
  __flush: function __flush(_ref2) {
    var _arguments = arguments,
        _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var state, commit, dispatch, maxRetryAttempts, attempts, submittedSurveys, _state$current$result, _state$current$result2, _state$current$result3, _state$current$result4, failedSubmit, request, args, response, _response$data, _response$data2, responseErrorMessage, offlineUploadNetworkError;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = _ref2.state, commit = _ref2.commit, dispatch = _ref2.dispatch;
              maxRetryAttempts = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 0;

              if (!state.current.flushInProgress) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              attempts = 0;
              submittedSurveys = 0;
              commit('__flushInProgress', true);
              _context2.prev = 7;

            case 8:
              if (!state.current.requests.length) {
                _context2.next = 43;
                break;
              }

              failedSubmit = false; // Pull out the one from the front so we're sending in order

              request = state.current.requests[0]; // A bit ugly, but always *try* to provide response headers as almost all api calls require it

              args = _objectSpread({}, request.args);
              args.headers = _objectSpread(_objectSpread({}, args.headers), {}, {
                responseId: (_state$current$result = state.current.results) === null || _state$current$result === void 0 ? void 0 : (_state$current$result2 = _state$current$result.submit) === null || _state$current$result2 === void 0 ? void 0 : _state$current$result2.id,
                // Identifies the survey response operated on
                responseSecret: (_state$current$result3 = state.current.results) === null || _state$current$result3 === void 0 ? void 0 : (_state$current$result4 = _state$current$result3.submit) === null || _state$current$result4 === void 0 ? void 0 : _state$current$result4.secret // Secures the operation

              }); // Wait on the response

              _context2.next = 15;
              return _this.$api[request.type](args);

            case 15:
              response = _context2.sent;

              // if the request is to submit the responses then we want to update the isAiValid value with the response value from the submit request
              if (request.type === 'submit') {
                commit('isAiValid', (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.is_ai_valid) || (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.isAiValid) || false);
              }

              responseErrorMessage = (response.error || {}).message;
              offlineUploadNetworkError = responseErrorMessage === 'Network Error' && request.offlineID > 0; // check to see if there is an error message if so we set the 'failedToSubmit' flag

              if (!responseErrorMessage) {
                _context2.next = 34;
                break;
              }

              if (offlineUploadNetworkError && state.responsesTemp.length > 0 || !offlineUploadNetworkError) {
                failedSubmit = true;
                commit('failedToSubmit', failedSubmit);
              } // If not an error related to a file upload - clear the errors log of the error from the api call so we can load the resubmit modal


              if (!response.error.detail.upload.errors) {
                dispatch('errors/clearError', null, {
                  root: true
                });
              }

              if (offlineUploadNetworkError) {
                _context2.next = 34;
                break;
              }

              if (!(maxRetryAttempts > 0)) {
                _context2.next = 33;
                break;
              }

              attempts++;

              if (!(attempts === maxRetryAttempts)) {
                _context2.next = 29;
                break;
              }

              attempts = 0;
              commit('__removeRequest');
              return _context2.abrupt("return", false);

            case 29:
              _context2.next = 31;
              return resubmitSurveyTimeout(3000);

            case 31:
              _context2.next = 34;
              break;

            case 33:
              commit('__removeRequest');

            case 34:
              if (!(!responseErrorMessage || offlineUploadNetworkError)) {
                _context2.next = 41;
                break;
              }

              // We need some error handling here, but assuming everything's fine, store the results of the most recent api call of this type
              attempts = 0;
              commit('__addRequestResult', {
                type: request.type,
                data: response.data
              });
              commit('submittedSurveys', ++submittedSurveys);
              commit('__removeRequest');

              if (!offlineUploadNetworkError) {
                _context2.next = 41;
                break;
              }

              return _context2.abrupt("return", state.responsesTemp.length === 0);

            case 41:
              _context2.next = 8;
              break;

            case 43:
              _context2.prev = 43;
              commit('__flushInProgress', false);
              return _context2.finish(43);

            case 46:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[7,, 43, 46]]);
    }))();
  },

  /**
   * Handle a generic request being enqueued
   *
   * @param {Object} state Vuex module state
   * @param {Function} commit Vuex module commit
   * @param {Object} rootState Vuex root state
   * @param {Object} rootGetters Vuex root getters
   * @param {Function} dispatch Vuex module dispatch
   *
   * @param request The request to be enqueued
   */
  __request: function __request(_ref3, request) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var state, rootState, rootGetters, dispatch, commit, matchingOfflineSurvey, timer;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = _ref3.state, rootState = _ref3.rootState, rootGetters = _ref3.rootGetters, dispatch = _ref3.dispatch, commit = _ref3.commit;
              commit('sending', true);

              if (!(!rootGetters['responses/__flushImmediately'] && !rootState.settings.hasConnectivity)) {
                _context3.next = 7;
                break;
              }

              // PWA with no connection
              if (request) {
                commit('__enqueueResponse', request);
              }

              setTimeout(function () {
                return commit('sending', false);
              }, 1000);
              _context3.next = 26;
              break;

            case 7:
              // SPA || PWA with connection
              matchingOfflineSurvey = state.responsesTemp.find(function (x) {
                return x.offlineID === state.current.offlineSurveyID;
              });

              if (matchingOfflineSurvey || request) {
                _context3.next = 12;
                break;
              }

              commit('failedToSubmit', true);
              commit('sending', false);
              return _context3.abrupt("return");

            case 12:
              if (matchingOfflineSurvey && request) {
                Object.assign(matchingOfflineSurvey.args.payload, request.args.payload);
              }

              commit('__enqueueRequest', matchingOfflineSurvey || request);

              if (rootState.settings.hasConnectivity) {
                _context3.next = 22;
                break;
              }

              // Time is in hundreths of a second (10 = 1sec)
              timer = 0;

            case 16:
              if (!(timeoutTime > timer && !rootState.settings.hasConnectivity)) {
                _context3.next = 22;
                break;
              }

              _context3.next = 19;
              return new Promise(function (r) {
                return setTimeout(r, 100);
              });

            case 19:
              timer++;
              _context3.next = 16;
              break;

            case 22:
              _context3.next = 24;
              return dispatch('__flush');

            case 24:
              if (matchingOfflineSurvey && !state.failedToSubmit) {
                commit('deleteResponsesTemp', state.responsesTemp.indexOf(matchingOfflineSurvey));
              }

              commit('sending', false);

            case 26:
              return _context3.abrupt("return", state.current.results);

            case 27:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  //////////////////////////////////////////////////////////////////////////////////////////////////
  //    ____     __         _         _
  //   / __/_ __/ /  __ _  (_)__ ___ (_)__  ___
  //  _\ \/ // / _ \/  ' \/ (_-<(_-</ / _ \/ _ \
  // /___/\_,_/_.__/_/_/_/_/___/___/_/\___/_//_/
  //
  //

  /**
   * Handle the submit phase of the survey process. The content consists of the core of the survey - e.g. question responses.
   *
   * @param {Function} commit Vuex module commit
   * @param {Object} rootGetters Vuex root getters
   * @param {Function} dispatch Vuex module dispatch
   */
  submit: function submit(_ref4) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var rootGetters, dispatch, commit, vdDateTime, adjustedDateTime, payload, eposData, tableNumber;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              rootGetters = _ref4.rootGetters, dispatch = _ref4.dispatch, commit = _ref4.commit;
              // Reset the 'failed to submit'
              commit('failedToSubmit', false); // Format visitDateTime as the value can be a string or a moment object. E.g Value is a string if user refreshes mid-survey.

              vdDateTime = rootGetters['checkIn/visitDetails'].datetime;
              adjustedDateTime = typeof vdDateTime === 'string' ? moment(vdDateTime) : vdDateTime; // source base content from across the store to start off the submit body

              payload = {
                visitDatetime: adjustedDateTime.format('YYYY-MM-DD HH:mm:ss'),
                surveyStart: rootGetters['checkIn/startTime'],
                surveyCompleted: moment().format('YYYY-MM-DD HH:mm:ss'),
                pinCode: rootGetters['checkIn/transactionRef'] || '',
                feedbackAlert: rootGetters['answers/feedbackAlerts'],
                managerFeedbackIndicatorRulePassed: rootGetters['answers/managerFeedbackIndicatorRulePassed'],
                recommendationPermitted: rootGetters['answers/recommendationPermitted'],
                userAgent: Platform.userAgent || '',
                staffId: rootGetters['settings/loggedInMember'],
                urlParams: rootGetters['checkIn/urlParams'],
                // Use the generated guid for the survey session, rather than creating a new one as this would
                // lead to multiple survey responses being sent tagged with different guids with the same
                // content.
                guid: rootGetters['checkIn/guid'],
                questionMap: rootGetters['questions/getQuestionsDetail'].questionMap || ''
              };
              eposData = rootGetters['checkIn/eposData'];

              if (eposData) {
                payload.transaction = eposData;
              }

              tableNumber = rootGetters['checkIn/tableNumber'];

              if (tableNumber || tableNumber === 0) {
                payload.url_params = {
                  table_id: tableNumber
                };
              } // allow question types to visit the submit body and mutate it


              rootGetters['answers/answers'].forEach(function (answer) {
                return answer.mutateSubmit(payload);
              }); // send the body on to the api

              _context4.next = 12;
              return dispatch('__request', {
                type: SUBMISSION_TYPES.SUBMIT,
                args: {
                  payload: {
                    create: payload
                  },
                  headers: {
                    templateId: rootGetters['questions/getSurvey'].templateId
                  }
                }
              });

            case 12:
              return _context4.abrupt("return", _context4.sent);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },

  /**
   * Handle the supplement phase of the survey process. This consists of optional guest details and related actions
   *
   * @param {Object} rootGetters Vuex root getters
   * @param {Function} dispatch Vuex module dispatch
   *
   * @param {Object} payload
   */
  supplement: function supplement(_ref5, payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var rootGetters, dispatch;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              rootGetters = _ref5.rootGetters, dispatch = _ref5.dispatch;
              _context5.next = 3;
              return dispatch('__request', payload ? {
                type: SUBMISSION_TYPES.SUBMIT,
                args: {
                  payload: {
                    supplement: payload
                  },
                  headers: {
                    templateId: rootGetters['questions/getSurvey'].templateId
                  }
                }
              } : null);

            case 3:
              return _context5.abrupt("return", _context5.sent);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },

  /**
   * Helper to implement the permitMarketing supplementary submission.
   *
   * @param {Function} dispatch Vuex module dispatch
   *
   * @param {Boolean} payload
   */
  permitMarketing: function permitMarketing(_ref6, payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var dispatch;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              dispatch = _ref6.dispatch;
              _context6.next = 3;
              return dispatch('supplement', {
                sharing: {
                  permitted: payload
                }
              });

            case 3:
              return _context6.abrupt("return", _context6.sent);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },

  /**
   * Handle the upload phase of the survey process. This allows a guest to upload a photo linked to their response.
   *
   * @param {Function} dispatch Vuex module dispatch
   *
   * @param {Boolean} payload
   */
  upload: function upload(_ref7, payload) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var dispatch;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              dispatch = _ref7.dispatch;
              _context7.next = 3;
              return dispatch('__request', {
                type: SUBMISSION_TYPES.UPLOAD,
                args: payload
              });

            case 3:
              return _context7.abrupt("return", _context7.sent);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },

  /**
   * Handle the delete upload phase of the survey process. This allows a guest to delete an uploaded photo linked to their response.
   *
   * @param {Function} dispatch Vuex module dispatch
   */
  deleteUpload: function deleteUpload(_ref8) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var dispatch;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              dispatch = _ref8.dispatch;
              _context8.next = 3;
              return dispatch('__request', {
                type: SUBMISSION_TYPES.DELETE_UPLOAD,
                args: {}
              });

            case 3:
              return _context8.abrupt("return", _context8.sent);

            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },

  /**
   * Handle the track phase of the survey process. This should currently be used to track when users have performed an action
   * with the survey response - e.g. sharing on Twitter. The full list of supported actions is available in track.request.json,
   * and available in FIB.TRACK_ACTIONS.
   *
   * @param {Function} dispatch Vuex module dispatch
   *
   * @param {Array} actions The set of actions performed
   */
  track: function track(_ref9, actions) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var dispatch;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              dispatch = _ref9.dispatch;
              _context9.next = 3;
              return dispatch('__request', {
                type: SUBMISSION_TYPES.TRACK,
                args: {
                  payload: {
                    actions: actions
                  }
                }
              });

            case 3:
              return _context9.abrupt("return", _context9.sent);

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  }
});

var getters = _objectSpread(_objectSpread({}, make.getters(state)), {}, {
  // Make default getters

  /**
   * Determine if requests should be flushed immediately or buffered
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Number} See FIB.US constants
   */
  __flushImmediately: function __flushImmediately(state, getters, rootState, rootGetters) {
    return rootGetters['config/getDeviceType'] !== 'app';
  },

  /**
   * Get the update state of survey responses.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Number} See FIB.US constants
   */
  updateState: function updateState(state) {
    var count = state.responsesTemp.length;
    var currentState = state.updateState;

    if (currentState === US.IN_PROGRESS) {
      return US.IN_PROGRESS;
    } else if (count > 0) {
      return US.PENDING;
    } else if (count === 0) {
      return US.DONE;
    } else {
      return US.UNKNOWN;
    }
  },

  /**
   * Gets the current result of the submit request or undefined if not yet available.
   * This contains the survey response id and public url to the scorecard.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Object} Returns the current result of the submit request or undefined if not yet  available
   */
  submitted: function submitted(state) {
    var _state$current$result5;

    return (_state$current$result5 = state.current.results) === null || _state$current$result5 === void 0 ? void 0 : _state$current$result5.submit;
  }
});

var mutations = _objectSpread(_objectSpread({}, make.mutations(state)), {}, {
  // Make default mutations

  /**
   * Reset the current state back to the default
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetCurrent: function resetCurrent(state) {
    state.current = cloneDeep(cleanCurrent);
  },

  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  },

  /**
   * Delete a survey in temporary storage.
   *
   * @param {Object} state Vuex module state
   * @param {Number} payload Array index
   *
   * @returns {Void}
   */
  deleteResponsesTemp: function deleteResponsesTemp(state, payload) {
    state.responsesTemp.splice(payload, 1); // Delete item at specified array index
  },

  /**
   * Provided for the app version only - at the end of a survey, this should be called to add the current
   * survey response to the queue of responses to be uploaded.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  __enqueueResponse: function __enqueueResponse(state, payload) {
    var _payload$args, _payload$args2;

    if ('create' in (payload === null || payload === void 0 ? void 0 : (_payload$args = payload.args) === null || _payload$args === void 0 ? void 0 : _payload$args.payload)) {
      var offlineID = state.responsesTemp.length + 1;
      payload.offlineID = offlineID;
      state.current.offlineSurveyID = offlineID;
      state.responsesTemp.push(payload);
    } else if ('supplement' in (payload === null || payload === void 0 ? void 0 : (_payload$args2 = payload.args) === null || _payload$args2 === void 0 ? void 0 : _payload$args2.payload)) {
      var matchingSubmit = state.responsesTemp.find(function (x) {
        return x.offlineID === state.current.offlineSurveyID;
      });

      if (matchingSubmit) {
        Object.assign(matchingSubmit.args.payload, payload.args.payload);
      }
    }
  },

  /**
   * Enqueue a request for the current response
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload Request content
   *
   * @returns {Void}
   */
  __enqueueRequest: function __enqueueRequest(state, payload) {
    // implement some rules on how enqueuing is allowed to happen
    // If we're enqueuing a survey.submit request to create a survey response..
    if (payload.type === SUBMISSION_TYPES.SUBMIT && 'create' in payload.args.payload) {
      // It's not allowed to if there's already an enqueued request to create it (otherwise you
      // could end up creating multiple for the same survey).
      if (state.current.requests.some(function (r) {
        return r.type === SUBMISSION_TYPES.SUBMIT && 'create' in r.args.payload;
      })) {
        return;
      } // If the survey's already been submitted, then it's too late.


      if (Object.prototype.hasOwnProperty.call(state.current.results, SUBMISSION_TYPES.SUBMIT)) {
        return;
      }
    } // deduplicate: for these types, only having the last instance of the type makes sense to send - e.g. don't upload 10 images, only the last one will be used.


    var dedupeTypes = [SUBMISSION_TYPES.UPLOAD, SUBMISSION_TYPES.DELETE_UPLOAD];

    if (dedupeTypes.includes(payload.type)) {
      removeAllOfType(state.current, payload.type);
    } // if we're still happy to enqueue, let's do so


    state.current.requests.push(payload);
  },

  /**
   * Remove a request for the current response
   *
   * @param {Object} state Vuex module state
   * @param {Number} payload Array index
   *
   * @returns {Void}
   */
  __removeRequest: function __removeRequest(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    state.current.requests.splice(payload, 1); // Delete item at specified array index
  },

  /**
   * Add the result of a request for the current response
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload Result content
   *
   * @returns {Void}
   */
  __addRequestResult: function __addRequestResult(state, payload) {
    Vue.set(state.current.results, payload.type, payload.data);
  },

  /**
   * Set the flushInProgress flag
   *
   * @param {Object} state Vuex module state
   * @param {Boolean} payload flushInProgress flag
   *
   * @returns {Void}
   */
  __flushInProgress: function __flushInProgress(state, payload) {
    state.current.flushInProgress = payload;
  }
});

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  namespaced: true
};